export class CloudPrincipalInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccountEmail",
            "baseName": "serviceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipalInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
